import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class LEDTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "indicatorColumn", title: "Indicator" },
        { name: "pirColumn", title: "PIR Detection" },
        { name: "mwColumn", title: "Microwave Detection" }
      ],
      rows: [
        { indicatorColumn: 'Rote LED konstant AN', pirColumn: 'Ja', mwColumn: 'Ja' },
        { indicatorColumn: 'Blaue LED blinken', pirColumn: 'Nein', mwColumn: 'Ja' },
        { indicatorColumn: 'Blaue LED konstant AN', pirColumn: 'Ja', mwColumn: 'Nein' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

LEDTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(LEDTable)